const productionGoogleMapsApiKey = 'AIzaSyBRR79it9lPoLWhrAjMCfmTL0baZ90v_CY';

const googleMapsApiKeyToBeUsed =
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_GOOGLE_MAPS_KEY
    ? process.env.REACT_APP_GOOGLE_MAPS_KEY
    : productionGoogleMapsApiKey;

const productionEnvironment = {
  checkr: {
    baseUrl: 'https://dashboard.checkr.com',
  },
  api: {
    baseUrl: 'https://api.hitch.net',
  },
  pusher: {
    key: '56148a4a9779c4829bcf',
  },
  googleapis: {
    apiKey: googleMapsApiKeyToBeUsed,
  },
  // Production GrowthBook SDK connection ("Admin Dashboard - Production", prod
  // environment). Flags still only surface when enabled in the prod GB
  // environment — `admin-trip-throttling` stays off there until the New Trip
  // Throttling prod rollout (HITCH-5249), so wiring this key changes nothing
  // rider- or ops-facing on its own.
  growthbook: {
    clientKey: 'sdk-D9X8CaCh6ftiLSZ',
    apiHost: 'https://cdn.growthbook.io',
  },
};

export default productionEnvironment;
